import {
    createActionCreator,
    createDeltaActionType,
    createSignalAction
} from '../../../setup-react';

// ===== Signals ============================================================ //

// Stats
export const FETCH_STATS_LEADERS = createSignalAction( 'statspro', 'FETCH_STATS_LEADERS' );
    
// Nav
export const UPDATE_NAV_ITEM = createSignalAction( 'statspro', 'UPDATE_NAV_ITEM' );

// Filters
export const UPDATE_FILTER_ITEM = createSignalAction( 'statspro', 'UPDATE_FILTER_ITEM' );
export const RESET_FILTERS = createSignalAction( 'statspro', 'RESET_FILTERS' );

// Sort
export const UPDATE_SORT = createSignalAction( 'statspro', 'UPDATE_SORT' );

// Benchmarking
export const UPDATE_BENCHMARKING = createSignalAction( 'statspro', 'UPDATE_BENCHMARKING' );

// ===== Deltas ============================================================= //

// Stats
export const SET_STATS_LEADERS = createDeltaActionType( 'statspro', 'SET_STATS_LEADERS' );
export const setStatsLeaders = createActionCreator( SET_STATS_LEADERS );

export const SET_STATS_LEADERS_REQUEST = createDeltaActionType( 'statspro', 'SET_STATS_LEADERS_REQUEST' );
export const setStatsLeadersRequest = createActionCreator( SET_STATS_LEADERS_REQUEST );

export const REMOVE_STATS_LEADERS_REQUEST = createDeltaActionType( 'statspro', 'REMOVE_STATS_LEADERS_REQUEST' );
export const removeStatsLeadersRequest = createActionCreator( REMOVE_STATS_LEADERS_REQUEST );

// Nav
export const SET_NAV_ITEM = createDeltaActionType( 'statspro', 'SET_NAV_ITEM' );
export const setNavItem = createActionCreator( SET_NAV_ITEM );

// Filters
export const SET_FILTER_ITEM = createDeltaActionType( 'statspro', 'SET_FILTER_ITEM' );
export const setFilterItem = createActionCreator( SET_FILTER_ITEM );

export const SET_RESET_FILTERS = createDeltaActionType( 'statspro', 'SET_RESET_FILTERS' );
export const setResetFilters = createActionCreator( SET_RESET_FILTERS );

// Sort
export const SET_SORT = createDeltaActionType( 'statspro', 'SET_SORT' );
export const setSort = createActionCreator( SET_SORT );

// Benchmarking
export const SET_BENCHMARKING = createDeltaActionType( 'statspro', 'SET_BENCHMARKING' );
export const setBenchmarking = createActionCreator( SET_BENCHMARKING );
